// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"3f4ac069","563":"c6eddbe1","909":"87a8047e"}[chunkId] + ".chunk.js";
};